export default __webpack_public_path__ + "static/media/math.854992fe.jpg";